// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2377":"css/admin-app.6868","7718":"css/app.6868"}[chunkId] + ".css";
};